import React from 'react';
import {
  ImageBlock,
  Render,
  Spinner,
  withSrcSets,
  withLazyLoad,
  withSensitiveImage,
} from '../platformui/';

const ImageBlockWithSrcSets = withLazyLoad(
  withSrcSets(withSensitiveImage(ImageBlock))
);
export default (props) => (
  <ImageBlockWithSrcSets
    {...props}
    ImageText={Render.Property(props.ImageText, 'ImageText')}
    SensitiveImageLoadingIcon={
      <Spinner Modifiers={{ 'c-spinner--sensitive-img-small': true }} />
    }
  />
);
